import moment from 'moment'
import { FilterOperator, PredefinedFilter } from 'app/filter.utils'

export const defaultBecameLeadDateFilter: PredefinedFilter = {
  [`becameLeadDate`]: {
    operator: `between` as FilterOperator,
    value: [moment().startOf(`month`).format(`YYYY-MM-DD`), moment().endOf(`month`).format(`YYYY-MM-DD`)],
    readOnly: true,
  },
}
